import request from "@/utils/request";

/** 我的排课 */
export function faceScheduleMy() {
  return request({ url: "/faceAuth/schedule/myList", method: "get" });
}

/** 我的课程（选课列表） */
export function faceCourseMyList(params) {
  return request({ url: "/faceAuth/course/myList", method: "get", params });
}

/** 学员首页仪表盘（欢迎区、统计、待办、近7天学习时长等） */
export function faceStudentDashboard() {
  return request({ url: "/faceAuth/dashboard/student", method: "get" });
}

/** 加入课程学习 */
export function faceCourseEnroll(data) {
  return request({ url: "/faceAuth/course/enroll", method: "post", data });
}

/** 个人中心：资料 + 学习概况 + 课时摘要 */
export function faceProfileMe() {
  return request({ url: "/faceAuth/profile/me", method: "get" });
}

export function faceProfileUpdate(data) {
  return request({ url: "/faceAuth/profile/me", method: "put", data });
}

export function faceProfilePassword(data) {
  return request({ url: "/faceAuth/profile/password", method: "put", data });
}

/** 我的作业 */
export function faceHomeworkList(params) {
  return request({ url: "/faceAuth/homework/list", method: "get", params });
}

/** 提交作业 */
export function faceHomeworkSubmit(data) {
  return request({ url: "/faceAuth/homework/submit", method: "post", data });
}

/** 我的考试 tab=all|pending|ended */
export function faceExamList(params) {
  return request({ url: "/faceAuth/exam/list", method: "get", params });
}

/** 题库列表 */
export function faceBankList(params) {
  return request({ url: "/faceAuth/bank/list", method: "get", params });
}

/** 工具库列表（支持 category、keyword） */
export function faceToolList(params) {
  return request({ url: "/faceAuth/tool/list", method: "get", params });
}

/** 工具分类（去重） */
export function faceToolCategories() {
  return request({ url: "/faceAuth/tool/categories", method: "get" });
}

/** 工具详情 */
export function faceToolDetail(toolId) {
  return request({ url: "/faceAuth/tool/" + toolId, method: "get" });
}

/** 某题库下的试卷列表（params.bankId 必填） */
export function faceQuizSetList(params) {
  return request({ url: "/faceAuth/quiz/set/list", method: "get", params });
}

/** 试卷题目（无答案）；params.bankId 用于校验归属题库 */
export function faceQuizPaper(setId, params) {
  return request({ url: "/faceAuth/quiz/paper/" + setId, method: "get", params });
}

/** 提交答卷 */
export function faceQuizSubmit(data) {
  return request({ url: "/faceAuth/quiz/submit", method: "post", data });
}

/** 单题判分（提交答案后展示解析） */
export function faceQuizGradeOne(data) {
  return request({ url: "/faceAuth/quiz/gradeOne", method: "post", data });
}

/** 答题 AI 评测/答疑（扣子 scene=quiz，如 python问卷） */
export function faceQuizAiChat(data) {
  return request({ url: "/faceAuth/quiz/aiChat", method: "post", data, timeout: 120000 });
}

/** 答题 AI 是否可用（扣子智能体是否已发布） */
export function faceQuizAiStatus() {
  return request({ url: "/faceAuth/quiz/aiStatus", method: "get" });
}

/** 门户扣子对话（可传 scene：global / quiz / practice） */
export function faceCozeChat(data) {
  return request({
    url: "/faceAuth/coze/chat",
    method: "post",
    data: data || {},
    timeout: 120000,
  });
}

/** AI 客服：扣子经后端代理（scene=global） */
export function faceCozeServiceStatus() {
  return request({ url: "/faceAuth/coze/status", method: "get" });
}

export function faceCozeServiceChat(data) {
  return request({
    url: "/faceAuth/coze/chat",
    method: "post",
    data: Object.assign({ scene: "global" }, data || {}),
    timeout: 120000,
  });
}

/* —— 管理端实训资源 —— */

export function trainScheduleList(params) {
  return request({ url: "/train/schedule/list", method: "get", params });
}
export function trainScheduleAdd(data) {
  return request({ url: "/train/schedule", method: "post", data });
}
export function trainScheduleEdit(data) {
  return request({ url: "/train/schedule", method: "put", data });
}
export function trainScheduleDel(scheduleId) {
  return request({ url: "/train/schedule/" + scheduleId, method: "delete" });
}

export function trainHomeworkList(params) {
  return request({ url: "/train/homework/list", method: "get", params });
}
export function trainHomeworkAdd(data) {
  return request({ url: "/train/homework", method: "post", data });
}
export function trainHomeworkEdit(data) {
  return request({ url: "/train/homework", method: "put", data });
}
export function trainHomeworkDel(homeworkId) {
  return request({ url: "/train/homework/" + homeworkId, method: "delete" });
}

export function trainExamList(params) {
  return request({ url: "/train/exam/list", method: "get", params });
}
export function trainExamAdd(data) {
  return request({ url: "/train/exam", method: "post", data });
}
export function trainExamEdit(data) {
  return request({ url: "/train/exam", method: "put", data });
}
export function trainExamDel(examId) {
  return request({ url: "/train/exam/" + examId, method: "delete" });
}

export function trainBankList(params) {
  return request({ url: "/train/bank/list", method: "get", params });
}
export function trainBankAdd(data) {
  return request({ url: "/train/bank", method: "post", data });
}
export function trainBankEdit(data) {
  return request({ url: "/train/bank", method: "put", data });
}
export function trainBankDel(bankId) {
  return request({ url: "/train/bank/" + bankId, method: "delete" });
}

export function trainToolList(params) {
  return request({ url: "/train/tool/list", method: "get", params });
}
export function trainToolAdd(data) {
  return request({ url: "/train/tool", method: "post", data });
}
export function trainToolEdit(data) {
  return request({ url: "/train/tool", method: "put", data });
}
export function trainToolDel(toolId) {
  return request({ url: "/train/tool/" + toolId, method: "delete" });
}

/* —— 题库答题（管理端） —— */

export function trainQuizSetList(params) {
  return request({ url: "/train/quiz/set/list", method: "get", params });
}
export function trainQuizSetAdd(data) {
  return request({ url: "/train/quiz/set", method: "post", data });
}
export function trainQuizSetEdit(data) {
  return request({ url: "/train/quiz/set", method: "put", data });
}
export function trainQuizSetDel(setId) {
  return request({ url: "/train/quiz/set/" + setId, method: "delete" });
}

export function trainQuizQuestionList(params) {
  return request({ url: "/train/quiz/question/list", method: "get", params });
}
export function trainQuizQuestionAdd(data) {
  return request({ url: "/train/quiz/question", method: "post", data });
}
export function trainQuizQuestionEdit(data) {
  return request({ url: "/train/quiz/question", method: "put", data });
}
export function trainQuizQuestionDel(questionId) {
  return request({ url: "/train/quiz/question/" + questionId, method: "delete" });
}

/** AI 出卷（管理端） */
export function trainQuizAiMeta() {
  return request({ url: "/train/quiz/aiGenerate/meta", method: "get" });
}
export function trainQuizAiGenerate(data) {
  return request({ url: "/train/quiz/aiGenerate", method: "post", data, timeout: 60000 });
}
export function trainQuizAiGeneratePoll(taskId) {
  return request({
    url: "/train/quiz/aiGenerate/task/" + encodeURIComponent(taskId),
    method: "get",
    timeout: 30000,
  });
}
export function trainQuizAiSave(data) {
  return request({ url: "/train/quiz/aiGenerate/save", method: "post", data });
}

/** AI 出卷（学员/门户） */
export function faceQuizAiMeta() {
  return request({ url: "/faceAuth/quiz/aiGenerate/meta", method: "get" });
}
export function faceQuizAiMyBank() {
  return request({ url: "/faceAuth/quiz/aiGenerate/myBank", method: "get" });
}
export function faceQuizAiGenerate(data) {
  return request({ url: "/faceAuth/quiz/aiGenerate", method: "post", data, timeout: 60000 });
}
export function faceQuizAiGeneratePoll(taskId) {
  return request({
    url: "/faceAuth/quiz/aiGenerate/task/" + encodeURIComponent(taskId),
    method: "get",
    timeout: 30000,
  });
}
export function faceQuizAiSave(data) {
  return request({ url: "/faceAuth/quiz/aiGenerate/save", method: "post", data });
}
